<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col :cols="12">
          <h1 class="headline font-weight-light mb-3">View Close Case</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
          <v-select
            class="pr-3"
            :items="projects"
            v-model="form.projects"
            item-text="project_name"
            item-value="project_id"
            multiple
            outlined
            dense
            clearable
            @blur="get_data()"
          >
            <template v-slot:label>
              <v-icon small class="mb-1" style="vertical-align: middle"
                >mdi-filter</v-icon
              >Filter Project
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip small v-if="index < 3">
                <span>{{ item.project_name }}</span>
              </v-chip>
              <span v-if="index === 3" class="grey--text caption">
                (+{{ form.projects.length - 3 }}
                others)
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            class="ma-0"
            v-model="form.searchtext"
            clearable
            dense
            outlined
            @input="
              pagination.current = 1;
              getCase(selectStatus);
            "
          >
            <template v-slot:label>
              <v-icon style="vertical-align: middle">mdi-magnify</v-icon>Case ID
            </template>
          </v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col v-if="team_name == 'NONHP'" cols="12" md="4">
          <v-select
            class="pr-3"
            :items="owners"
            v-model="form.owner"
            item-text="created_name"
            item-value="created_by"
            clearable
            outlined
            dense
            @blur="get_data()"
          >
            <template v-slot:label>
              <v-icon small class="mb-1" style="vertical-align: middle"
                >mdi-filter</v-icon
              >Filter Owner
            </template>
            <!-- <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index < 2">
              <span>{{ item.created_name }}</span>
            </v-chip>
            <span v-if="index === 3" class="grey--text caption">
              (+{{ form.owner.length - 3 }}
              others)
            </span>
          </template> -->
          </v-select>
        </v-col>
        <v-col cols="12" sm="4" class="text-right">
          <v-tooltip
            bottom
            v-if="
              wait_happycall > 0 && happycalltab == true && team_name != 'NONHP'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                class="ma-2"
                color="indigo"
                text-color="white"
                v-bind="attrs"
                v-on="on"
              >
                <v-avatar left>
                  <v-icon>mdi-face-agent</v-icon>
                </v-avatar>
                Waiting Happy Call : {{ wait_happycall }} เคส
              </v-chip>
            </template>
            <span v-for="(datawaithpc, idx) in datawaithapyycall" :key="idx">
              <div>
                {{ datawaithpc.onsite_date }} --> {{ datawaithpc.num_case }} เคส
              </div>
            </span>
          </v-tooltip>
          <div v-else-if="happycalltab == false">
            <v-progress-linear indeterminate color="cyan"></v-progress-linear>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(item, index) in arr_card" :key="index" :md="2" :sm="3">
          <v-card
            @click="selectCard(item.text)"
            :color="selected == item.text ? 'grey lighten-3 ' : 'white'"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <b style="font-size: 15px">{{ item.project }}</b>
              </v-list-item-content>
              <v-btn elevation="0" fab dark small :color="item.color">{{
                item.num
              }}</v-btn>
            </v-list-item>
            <v-system-bar :height="4" dark :color="item.color"> </v-system-bar>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="left">
        <v-col v-for="(item, index) in adminbooking" :key="index" cols="3">
          <span>{{ item.admin_name }} - {{ item.num_case }}</span>
        </v-col>
      </v-row>
    </v-container>
    <table-view-case
      @click-me="view"
      @return-click="returncase"
      @booking-click="bookingCase"
      @getSummary-click="getSummary"
      @getCase-click="getCase"
      :condition="condition"
      :closecasecondition="selectStatus"
      :data_case="data_case"
      :casetab="casetab"
      :text1="text1"
    />

    <div class="text-center pa-5">
      <v-pagination
        @input="onPageChange"
        v-model="pagination.current"
        :length="data_case.last_page"
        circle
      ></v-pagination>
    </div>
    <v-dialog
      ref="dialog"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close_detail()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>View Detail Case</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="ml-10 mr-10">
          <head-information
            @closecase-click="data_check"
            @rejectcase-click="rejectcase"
            @changeincomplete-click="changeincomplete"
            @changecomplete-click="changecomplete"
            @returncasetoce-click="returncasetoceconfirm"
            :status="chkstatus"
            :team="condition.team"
            :detailcase="detailcase"
          />

          <!-- && detailcase.skip_ismart == 'N' -->
          <view-caseinformation :detailcase="detailcase" />
          <view-productinformation :detailcase="detailcase" />
          <view-customerinformation :detailcase="detailcase" />
          <view-engineerformation
            :status="condition.status"
            :detailcase="detailcase"
            :active_tab="0"
          />
          <view-hpipartformation
            v-if="team_name != 'NONHP'"
            :detailcase="detailcase"
          ></view-hpipartformation>
          <view-partformation v-else :detailcase="detailcase" />
          <!-- <view-attachformation :detailcase="detailcase" /> -->
          <view-loginformation
            :detailcase="detailcase"
            :status="condition.status"
          />
          <view-eegclosecase
            @closecase-eeg-click="closecase_eeg"
            :detailcase="detailcase"
            v-if="
              detailcase.skip_ismart == 'N' &&
                selectStatus == 'Booking' &&
                detailcase.project_name == 'CDAX'
            "
          />
          <view-hpcformation :detailcase="detailcase" />

          <!-- <view-performanceformation :detailcase="detailcase" /> -->
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ actions.status }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="actions.remark" label="Remark"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog2 = false"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveActions(actions.status)"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogincomplete" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Change Status
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-radio-group
              v-if="detailcase.warranty_type == 'IW'"
              v-model="change_status.quotation"
              row
              :rules="[(v) => !!v || 'Quotation required']"
            >
              <v-radio label="เสนอราคา" value="Y"></v-radio>
              <v-radio label="ไม่เสนอราคา" value="N"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="change_status.remark"
              label="Remark"
              :rules="[(v) => !!v || 'Remark required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialogincomplete = false"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            color="primary"
            text
            @click="saveincomplete()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogcomplete" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Change Status
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="change_status.remark"
            label="Remark"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialogcomplete = false"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="savecomplete()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRating" persistent max-width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          CE Closing Summary Rating
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h3>
                <span class="primary--text font-b">{{
                  detailcase.closing_summary_ce
                }}</span>
              </h3>
            </v-col>
            <v-col cols="12">
              <star-rating v-model="rating" :show-rating="false"></star-rating>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                label="หมายเหตุ..."
                required
                v-model="rating_comment"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text small @click="dialogRating = false"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="rating == 0"
            small
            rounded
            @click="rate_ismart()"
            >Save Rating</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_loading" v-if="dialog_loading == true" hide-overlay persistent width="320">
      <v-card color="primary" dark>
        <v-card-text>
          <span class="mt-1 white--text">Loading</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import StarRating from "vue-star-rating";

import TableViewCase from "../components/TableViewCase";
import MaterialStatsCard from "../../../components/StatsCard";

import HeadInformation from "../components/HeadInformation";
import ViewCaseInformation from "../components/ViewCaseInformation";
import ViewProductInformation from "../components/ViewProductInformation";
import ViewCustomerInformation from "../components/ViewCustomerInformation";
import ViewEngineerInformation from "../components/ViewEngineerInformation";
import ViewPartInformation from "../components/ViewPartInformation";
import ViewHpiPartInformation from "../components/ViewHpiPartInformation";
import ViewLogInformation from "../components/ViewLogInformation";
import ViewAttachInformation from "../components/ViewAttachInformation";
import ViewHpcInformation from "../components/ViewHpcInformation";
import ViewPerformanceInformation from "../components/ViewPerformanceInformation";
import EegCloseCase from "../components/EegCloseCase.vue";
import { get } from "lodash";
const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
  components: {
    "table-view-case": TableViewCase,
    "base-material-stats-card": MaterialStatsCard,
    "head-information": HeadInformation,
    "view-caseinformation": ViewCaseInformation,
    "view-customerinformation": ViewCustomerInformation,
    "view-productinformation": ViewProductInformation,
    "view-loginformation": ViewLogInformation,
    "view-attachformation": ViewAttachInformation,
    "view-hpipartformation": ViewHpiPartInformation,
    "view-partformation": ViewPartInformation,
    "view-engineerformation": ViewEngineerInformation,
    "view-hpcformation": ViewHpcInformation,
    "view-performanceformation": ViewPerformanceInformation,
    "view-eegclosecase": EegCloseCase,
    StarRating,
  },
  computed: {
    ...mapState(["isLoading"]),
  },
  beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
  mounted() {

    this.getCase("Pending");
    this.getSummary();
    this.getProject();

    var team = ["SUPPORTUC", "PSG", "IPG"];
    var chk = team.includes(localStorage.team_name);

    this.chkstatus = chk === true ? "ViewCloseCase" : "CloseCase";
    if (chk === true) {
      this.condition.is_skip = false;
    }
  },
  data() {
    return {
      selected: "Pending",
      rating: 0,
      rating_comment: "",
      chk_rate_ismart: false,
      dialogRating: false,
      owners: [],
      datas: {
        project_id: [],
        owner: "",
      },
      text1: "",
      happycalltab: false,
      casetab: false,
      team_name: localStorage.team_name,
      detailcase: [],
      no: 1,
      wait_happycall: 0,
      datawaithapyycall: [],
      data: [],
      chkstatus: "",
      condition: {
        team: "",
        status: "CloseCase",
        is_skip: true,
      },
      actions: {
        status: "",
        remark: "",
      },
      change_status: {
        quotation: "",
        remark: "",
      },
      dialog: false,
      dialog2: false,
      dialogincomplete: false,
      dialogcomplete: false,
      search: "",
      url: process.env.VUE_APP_ROOT_API,
      data_case: [],
      form: {
        projects: [],
        searchtext: "",
        owner: "",
      },
      projects: [],
      selectStatus: "Pending",
      status: [],
      pagination: {
        current: 1,
      },
      data_summary: [],
      arr_card: [
        {
          project: "Waiting Close",
          text: "Pending",
          color: "orange darken-3",
          icon: "mdi-account-clock",
          num: "0",
        },
        {
          project: "CDAX - EEG",
          text: "ismart",
          color: "blue darken-4",
          icon: "mdi-account-clock",
          num: "0",
        },
        {
          project: "ZQTM / Up Warranty",
          text: "Waiting ZQTM",
          color: "green darken-2",
          icon: "mdi-file-document-multiple-outline",
          num: "0",
        },
        {
          project: "Rejected",
          text: "Rejected",
          color: "red darken-2",
          icon: "mdi-clipboard-alert-outline",
          num: "0",
        },
        {
          project: "Booking",
          text: "Booking",
          color: "brown darken-1",
          icon: "mdi-tag-faces",
          num: "0",
        },
        {
          project: "Recheck",
          text: "Recheck",
          color: "amber darken-1",
          icon: "mdi-tag-faces",
          num: "0",
        },
      ],
      adminbooking: [],
      valid: false,
      FE_Survey_URL:null,
      DialogClosecase:false,
      without_encode:false,
      dialog_loading:false,
      overlay :false
    };

  },
  methods: {
    ...mapMutations(["mutatesnackbar"]),

    ...mapMutations(["mutateIsLoading"]),
    returncasetoceconfirm(c) {
      this.$swal({
        title: "Confirm Return Case " + c + " To CE ?",
        text: "",
        icon: "warning",
        buttons: true,
        primaryMode: true,
      }).then((confirm) => {
        if (confirm) {
          this.returncasetoce();
        } else {
          // console.log("--no")
        }
      });
    },
    async returncasetoce() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/it/task/save-return-case`;
      var sent = {
        date: this.detailcase.subs[this.detailcase.subs.length - 1].onsite_at,
        engineer:
          this.detailcase.subs[this.detailcase.subs.length - 1].engineer,
        subcase_id:
          this.detailcase.subs[this.detailcase.subs.length - 1].subcase_id,
      };
      try {
        const { data } = await axios.post(url, sent, options);
        this.getDetail();
        this.dialog = false;
      } catch (error) {
        console.log(error);
      }
    },





    async saveActions(params) {
      const url =
        params == "Reject Case"
          ? `${process.env.VUE_APP_ROOT_API}/api/rejected-case/${this.detailcase.maincase_id}`
          : `${process.env.VUE_APP_ROOT_API}/api/void-case/${this.detailcase.maincase_id}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const body = {
        remark: this.actions.remark,
      };
      try {
        this.mutateIsLoading();
        const { data } = await axios.post(`${url}`, body, options);
        if (data != "") {
          this.dialog = false;
          this.dialog2 = false;
          this.getCase(this.selectStatus);
          this.getSummary();
          this.mutateIsLoading();
        }
      } catch (error) {
        console.log(error);
      }
    },
    rejectcase() {
      this.actions.status = "Reject Case";
      this.dialog2 = true;
    },
    async returncase(params) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/return-case/${params}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };

      const { data } = await axios.post(`${url}`, [], options);
      if (data != "return - complete") {
        swal({
          title: "Upload error",
          icon: "error",
          button: "OK",
        });
      } else {
        this.mutatesnackbar();
        this.text1 = "Return success";
        setTimeout(() => {
          this.mutatesnackbar();
          this.text1 = "";
        }, 2000);
      }
      this.getCase(this.selectStatus);
      this.getSummary();
    },
    async bookingCase(params) {
      const url = `${process.env.VUE_APP_ROOT_API}/api/booking-case/${params}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };

      const { data } = await axios.post(`${url}`, [], options);

      if (data != "book - complete") {
        swal({
          title: data.error,
          icon: "error",
          button: "OK",
        });
      } else {
        this.mutatesnackbar();
        this.text1 = "Booking success";
        setTimeout(() => {
          this.mutatesnackbar();
          this.text1 = "";
        }, 2000);
      }
      this.getCase(this.selectStatus);
      this.getSummary();
    },
    async view(params) {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${params}`;
      try {
        const { data } = await axios.get(`${url}`, options);
        this.detailcase = [];
        console.log(data, "-casedetail");
        this.detailcase = data;
        this.dialog = true;
        console.log('detailcase',this.detailcase)
      } catch (error) {
        console.log(error);
      }
    },
    get_data() {

      this.getCase(this.selectStatus);

      this.getSummary();
    },
    getSummary: _.debounce(async function () {
      this.happycalltab = false;
      this.dates = {
        project_id: "",
        owner: "",
      };
      if (
        this.form.owner != null &&
        this.form.owner != undefined &&
        this.form.owner != ""
      ) {
        this.datas.project_id = this.form.projects;
        this.datas.owner = this.form.owner;
      } else {
        this.datas.project_id = this.form.projects;
        this.datas.owner = "";
      }

      const url = `${process.env.VUE_APP_ROOT_API}/api/close-case/summary`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      try {
        this.arr_card.map((each, index) => {
          this.arr_card[index].num = 0;
        });
        const { data } = await axios.post(`${url}`, this.datas, options);
        // console.log(data, "hh");
        this.data_summary = data.main;
        this.data_summary.map((each, index) => {
          switch (each.status) {
            case "Pending":
              this.arr_card[0].num = each.num_rows;
              break;
            case "ismart":
              this.arr_card[1].num = each.num_rows;
              break;
            case "Waiting ZQTM":
              this.arr_card[2].num = each.num_rows;
              break;
            case "Rejected":
              this.arr_card[3].num = each.num_rows;
              break;
            case "Booking":
              this.arr_card[4].num = each.num_rows;
              break;
            case "Recheck":
              this.arr_card[5].num = each.num_rows;
              break;
          }
        });
        this.datawaithapyycall = [];
        this.wait_happycall = 0;
        data["wait_happycall"].map((each) => {
          this.wait_happycall += parseInt(each.num_case);
        });
        this.happycalltab = true;
        this.datawaithapyycall = data.wait_happycall;
        this.adminbooking = data.summary_book;
      } catch (error) {
        console.log(error);
      }
    }, 1000),
    rate_ismart() {
      this.chk_rate_ismart = true;
      this.closecase();
    },

    closecase_eeg() {
      this.closecase();
      // this.getCase(this.selectStatus)
      // this.getSummary()
      // this.mutateIsLoading()
    },

    async closecase() {
      if (
        this.detailcase.sms_status == "Y" &&
        this.detailcase.sms_language != null
      ) {
        let str;
        if (this.detailcase.sms_language == "th") {
          str = `งานซ่อมหมายเลข ${this.detailcase.case_id} ได้รับการแก้ไขเรียบร้อยแล้ว แชร์ความคิดเห็นของคุณและให้กำลังใจช่างของเราได้ที่ ${this.FE_Survey_URL} (ลิงก์มีอายุ 14 วัน) ขอบคุณที่ให้ทาง HP ได้ดูแลคุณ  สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`;
        } else if (this.detailcase.sms_language == "en") {
          str = `Case no: ${this.detailcase.case_id} has been successfully resolved. Please share your feedback and support our technician at ${this.FE_Survey_URL} (link valid for 14 days). Thank you for allowing HP to serve you. if you have any queries, please contact 020781589`;
        }
        let str_th = str;
        str = str
          .split("")
          .map((char) => addZeros(char.charCodeAt(0).toString(16)))
          .join("");
        // console.log(str)
        function addZeros(str) {
          return ("0000" + str).slice(-4);
        }
        this.detailcase.str = str;
        this.detailcase.str_th = str_th;

        this.detailcase.sms_language = this.detailcase.sms_language;
        this.detailcase.sms_status = this.detailcase.sms_status;

      }

      console.log('data',this.detailcase)
      if (
          this.detailcase.rate_ismart == "Y" &&
          this.chk_rate_ismart == false
      ) {
          this.dialogRating = true
      } else {
          const url = `${process.env.VUE_APP_ROOT_API}/api/closed-case/${this.detailcase.maincase_id}`
          const options = {

              headers: {
                  Authorization: "Bearer " + localStorage.token,
              },
          }
          this.mutateIsLoading()
          const { data } = await axios.post(
              `${url}`,
              {
                  log_note: this.detailcase.text_closecase,
                  rating: this.rating,
                  rating_comment: this.rating_comment,
                  str: this.detailcase.str,
                  str_th: this.detailcase.str_th,
                  customer_tel: this.detailcase.customer_tel,
                  sms_language: this.detailcase.sms_language,
                  sms_status: this.detailcase.sms_status,
                  project_name: this.detailcase.project_name,
                  subcase_id: this.detailcase.subcase_id,
              },
              options
          )
          if (data != "closed - complete") {
              swal({
                  title: "Upload error",
                  icon: "error",
                  button: "OK",
              })
          } else {
              this.dialogRating = false
              this.chk_rate_ismart = false
              this.rating = 0
              this.rating_comment = ""

              this.getCase(this.selectStatus)
              this.getSummary()
              this.close_detail()
              
              this.mutateIsLoading()
          }
      }

    
    },




    getCase: _.debounce(async function (params) {
        console.log("param",params)
      this.casetab = false;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/close-case/view/${params}?page=${this.pagination.current}`;
      try {
        const { data } = await axios.post(`${url}`, this.form, options);
        this.pagination.current = data.current_page;
        this.data_case = data;
        // console.log(this.data_case, "-data_case")
        this.casetab = true;
      } catch (error) {
        console.log(error);
      }
    }, 1000),
    async getProject() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/filtercase`;
      try {
        const { data } = await axios.get(`${url}`, options);
        this.projects = data.projects;
        this.owners = data.owner;
        this.status = data.main_status;
      } catch (error) {}
    },
    onPageChange() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.getCase(this.selectStatus);
      this.getSummary();
    },
    selectCard(params) {
      console.log(params, "--params");
      this.selected = params;
      this.getSummary();
      this.getCase(params);

      var team = ["SUPPORTUC", "PSG", "IPG"];
      var chk = team.includes(localStorage.team_name);
      this.chkstatus =
        params == "Booking" || chk !== true ? "CloseCase" : "ViewCloseCase";

      setTimeout(() => {
        this.selectStatus = params;
      }, 1000);
    },
    close_detail() {
      // console.log(this.detailcase.maincase_id)
      this.detailcase = [];
      this.dialog = false;
      this.dialog_loading = false
    },

    changeincomplete() {
      this.change_status.quotation =
        this.data_case.warranty_type == "OOW" ? "Y" : "";
      this.dialogincomplete = true;
      this.$refs.form.validate();
    },
    async saveincomplete() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/change-to-incomplete/${this.detailcase.maincase_id}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      this.mutateIsLoading();
      const { data } = await axios.post(`${url}`, this.change_status, options);
      this.dialogincomplete = false;
      this.getCase(this.selectStatus);
      this.getSummary();
      this.mutateIsLoading();
    },
    changecomplete() {
      this.dialogcomplete = true;
    },
    async savecomplete() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/change-to-complete/${this.detailcase.maincase_id}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      this.mutateIsLoading();
      const { data } = await axios.post(`${url}`, this.change_status, options);
      this.dialogincomplete = false;
      this.getCase(this.selectStatus);
      this.getSummary();
      this.mutateIsLoading();
    },
    call_dialog_loadiong(){
      this.dialog_loading = true
    },

    async data_check(){
      this.call_dialog_loadiong()
      if(this.detailcase.sms_status != "Y"){
        this.dialog_loading = false
        this.closecase()
      }else{
        this.call_dialog_loadiong()
        const send = {
          hp_learnerid: this.detailcase.subs[this.detailcase.subs.length - 1].engineer_hp_learnerid,
          case_id:this.detailcase.case_id
      }
        await axios.post(`${url}get-fe-survey`,send,this.tk)
        .then((respond) => {
          this.FE_Survey_URL = respond.data
          this.dialog_loading = false

          this.closecase()

        })
        .catch((error) => {
            console.log(error)
        })
        }
      }
    },
  
}
</script>
